/**
 * DDSStatsCards Component
 * Displays statistics cards for DDS module
 */
import { Card, CardContent } from '../ui/card';
import { Video, CheckCircle, Eye, Tag } from 'lucide-react';

const StatCard = ({ icon: Icon, title, value, gradientFrom, gradientTo }) => (
  <Card className={`bg-gradient-to-br from-${gradientFrom} to-${gradientTo} text-white`}>
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <Icon className="w-8 h-8 opacity-80" />
        <div>
          <p className="text-sm opacity-80">{title}</p>
          <p className="text-2xl font-bold">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const DDSStatsCards = ({ stats, categoriesCount }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="dds-stats">
      <Card className="bg-gradient-to-br from-amber-500 to-amber-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Video className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Total de DDS</p>
              <p className="text-2xl font-bold">{stats.total}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-green-500 to-green-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <CheckCircle className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Ativos</p>
              <p className="text-2xl font-bold">{stats.ativos}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Eye className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Views (30 dias)</p>
              <p className="text-2xl font-bold">{stats.visualizacoes_30_dias}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <Tag className="w-8 h-8 opacity-80" />
            <div>
              <p className="text-sm opacity-80">Categorias</p>
              <p className="text-2xl font-bold">{categoriesCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DDSStatsCards;
